export default __webpack_public_path__ + "media/zurb/img/contact/contact1-a82533850b7e10bb4f340bf44bd2a4d7.png";